import React, { useCallback } from 'react';
import { UploadCloud, FileUp } from 'lucide-react';

interface UploadZoneProps {
  onFileLoaded: (content: string, fileName: string) => void;
}

export const UploadZone: React.FC<UploadZoneProps> = ({ onFileLoaded }) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target?.result as string;
      onFileLoaded(content, file.name);
    };
    reader.readAsText(file);
  };

  return (
    <div className="w-full max-w-xl mx-auto mt-10">
      <label 
        htmlFor="gpx-upload"
        className="flex flex-col items-center justify-center w-full h-64 border-2 border-dashed rounded-2xl cursor-pointer border-slate-700 bg-slate-900/50 hover:bg-slate-800/50 hover:border-cyan-500 transition-all duration-300 group"
      >
        <div className="flex flex-col items-center justify-center pt-5 pb-6 text-slate-400 group-hover:text-cyan-400">
          <UploadCloud className="w-16 h-16 mb-4 transition-transform group-hover:scale-110 duration-300" />
          <p className="mb-2 text-lg font-medium">
            <span className="font-bold">Click to upload</span> or drag and drop
          </p>
          <p className="text-sm text-slate-500">GPX files only (Pump Foil, Wing Foil, SUP)</p>
        </div>
        <input 
          id="gpx-upload" 
          type="file" 
          accept=".gpx" 
          className="hidden" 
          onChange={handleFileChange}
        />
      </label>
    </div>
  );
};
